/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Algorithm_No_Practical_ExperienceInputs */

const en_matching_score_algorithm_no_practical_experience = /** @type {(inputs: Matching_Score_Algorithm_No_Practical_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No practical experience provided.`)
};

const de_matching_score_algorithm_no_practical_experience = /** @type {(inputs: Matching_Score_Algorithm_No_Practical_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Praxiserfahrung angegeben.`)
};

/**
* | output |
* | --- |
* | "No practical experience provided." |
*
* @param {Matching_Score_Algorithm_No_Practical_ExperienceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_algorithm_no_practical_experience = /** @type {((inputs?: Matching_Score_Algorithm_No_Practical_ExperienceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Algorithm_No_Practical_ExperienceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_algorithm_no_practical_experience(inputs)
	return en_matching_score_algorithm_no_practical_experience(inputs)
});